import { useQuery } from '@tanstack/react-query';
import type { BannerSectionsData } from '@/common/types/banner-section.type';
import Client from '@/common/utils/client.utility';

export type {
  BannerSectionsData,
  PublicBanner,
  PublicBannerSection,
  PublicBannerSectionType,
} from '@/common/types/banner-section.type';

export interface Banner {
  id: number;
  title: string;
  link: string;
  active: false;
  createdDateTime: string | null;
  editedDateTime: string | null;
  desktopMediaFileUrl: string;
  mobileMediaFileUrl: string;
  adminUserId: number;
  adminFirstName: string;
  adminLastName: string;
}

export interface BannerData {
  data: {
    banners: Banner[];
  };
}

export const GetHomeBanners = async () => {
  const client = new Client(true);
  return await client.get<BannerData>(`/v1/Banner/GetBanners`);
};

export const GetBannerSections = async () => {
  const client = new Client(true);
  return await client.get<BannerSectionsData>(`/v1/Banner/GetBannerSections`);
};

export const useBannerSections = () =>
  useQuery({
    queryKey: ['Get-Banner-Sections'],
    queryFn: GetBannerSections,
    staleTime: 60_000,
  });
